import styled from 'styled-components';

export const Action = styled.button`
  border: 0;
  background-color: transparent;
  cursor: pointer;
`;

export default Action;
